import $ from "jquery";
import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export class CustomCommissionsController extends Controller {
  static targets = ["eventCommissionUnit", "ticketCommissionUnit", "submit"];
  static values = {
    commission: String,
    sales: Boolean,
  };

  connect() {
    this.toggleCommission();
  }

  toggleCommission() {
    const commissionType = this.element.querySelector("input[name='custom_commission_form[commission]']:checked").value;

    if (commissionType === this.commissionValue) {
      this.show(this.eventCommissionUnitTarget);
      this.hide(this.ticketCommissionUnitTarget);
    } else {
      this.show(this.ticketCommissionUnitTarget);
      this.hide(this.eventCommissionUnitTarget);
    }
    this.action();
  }

  show(element) {
    $(element).slideDown(10);
  }

  hide(element) {
    $(element).slideUp(10);
  }

  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      "modal",
    );
    modalController.show();
  }

  action() {
    if (!this.salesValue) {
      this.submitTarget.removeAttribute("aria-disabled");
    }
  }
}

// Connects to data-controller="commission-preview-form"
export class CommissionPreviewFormController extends Controller {
  static targets = ["form"];

  request(attributes) {
    const formData = new FormData(this.formTarget);

    formData.append("reception_id", attributes["receptionId"]);
    const params = new URLSearchParams(formData);

    post(this.formTarget.action, {
      body: params.toString(),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      responseKind: "turbo-stream",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("プレビューに失敗しました。");
        }
      })
      .catch((error) => {
        alert(error.message);
      });
  }
}

// Connects to data-controller="commission-preview"
export class CommissionPreviewController extends Controller {
  static targets = ["receptionId"];
  static outlets = ["commission-preview-form"];

  preview(event) {
    event.preventDefault();

    const attributes = {
      receptionId: this.receptionIdTarget.value,
    };

    this.commissionPreviewFormOutlet.request(attributes);
  }
}
